<template>
  <b-button class="reorder-button mt-1 mt-sm-0">
    <div class="d-flex align-items-center">
      <reorder-icon class="mr-1 reorder-icon" v-if="!mode" />
      <view-eye class="mr-1 reorder-icon" v-else />
      <span>{{ mode ? 'View' : 'Reordering' }}</span>
    </div>
  </b-button>
</template>

<script>
  import { BButton } from 'bootstrap-vue';
  import ReorderIcon from '@/@core/components/svg/common/Reorder.vue';
  import ViewEye from '@/@core/components/svg/button/ViewEye.vue';

  export default {
    components: {
      BButton,
      ReorderIcon,
      ViewEye,
    },
    props: {
      mode: { type: Boolean, default: false },
    },
  };
</script>

<style scoped>
  .reorder-icon {
    width: 16px;
    height: auto;
  }

  .reorder-button,
  .reorder-button:focus {
    background-color: #e5efff !important;
    border-color: #e5efff !important;
    color: #0064fa !important;
  }

  .reorder-button {
    padding: 10px 10px;
    fill: #0064ff;
  }

  .reorder-button:hover:not(.disabled):not(:disabled) {
    box-shadow: 0 8px 25px -8px var(#0064fa) !important;
  }
</style>
